import { useMemo } from 'react'
import { calcVegas } from './ggVegas.js'
import { sampleTeams, samplePars } from './ggSamplePlayers.js'

// G-Vegas — isolated sandbox. Two teams form two-digit numbers (low ball first);
// a birdie flips the opponent's number; lower banks the diff. calcVegas ported
// from GolfGamesScorecard. Uses the first two sample teams.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GVegas() {
  const [t1, t2] = useMemo(() => sampleTeams().slice(0, 2), [])
  const r = useMemo(() => calcVegas(t1, t2, samplePars()), [t1, t2])
  const nm = (t) => t.map((p) => p.name.split(' ')[0]).join(' & ')

  return (
    <div className="card">
      <p className="text-sm mb-3">Winner: <b>{r.winner}</b></p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Team', 'Points'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>
          <tr><td style={cell}>Team 1 · {nm(t1)}</td><td style={cell}><b>{r.t1Total}</b></td></tr>
          <tr><td style={cell}>Team 2 · {nm(t2)}</td><td style={cell}><b>{r.t2Total}</b></td></tr>
        </tbody>
      </table>
    </div>
  )
}
